import { render, staticRenderFns } from "./consentPopUp.vue?vue&type=template&id=70de5cb3&scoped=true&lang=pug"
import script from "./consentPopUp.vue?vue&type=script&lang=js"
export * from "./consentPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de5cb3",
  null
  
)

export default component.exports